/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 *
 *
 * @export
 * @interface SurveyPendingTableDto
 */
export interface SurveyPendingTableDto {
  /**
   * Unique identifier of the survey.
   *
   * @type {string}
   * @memberof SurveyPendingTableDto
   * @example 123e4567-e89b-12d3-a456-426614174000
   */
  id: string;

  /**
   * Name of the survey.
   *
   * @type {string}
   * @memberof SurveyPendingTableDto
   * @example Patient Satisfaction Survey
   */
  name: string;

  /**
   * Number of days left to answer the survey.
   *
   * @type {number}
   * @memberof SurveyPendingTableDto
   * @example 7
   */
  days_left: number;

  /**
   * Priority level of the survey.
   *
   * @type {string}
   * @memberof SurveyPendingTableDto
   * @example mandatory
   */
  priority: SurveyPendingTableDtoPriorityEnum;

  /**
   * Whether the user has a saved draft for this survey.
   *
   * @type {boolean}
   * @memberof SurveyPendingTableDto
   * @example false
   */
  has_draft: boolean;
}

/**
 * @export
 * @enum {string}
 */
export enum SurveyPendingTableDtoPriorityEnum {
  Mandatory = 'mandatory',
  Optional = 'optional',
}
